import createModel, { prop } from './lib/create_model';

export default createModel({
  modelName: 'VoiceConfiguration',
  properties: {
    callWrapUpIntervalSecs: prop(Number).default(60),
    declineCallAutoReadyIntervalSecs: prop(Number).default(20),
    disableOutboundCallList: prop(Array).default([]),
    hotelingEnabled: prop(Boolean).default(false),
    shouldAutoOpenCallNote: prop(Boolean).default(true),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/voice_configuration.js